import React, {useEffect, useState, useRef, ReactNode} from 'react'
import {throttle} from 'lodash'
import clsx from 'clsx'
import {closeCurWindow} from '@xc/hiya-jsbridge'

import {useEnv} from 'hiya-common/src/reducers/env'

import styles from './index.module.scss'

interface IBasicProps {
  title?: string | ReactNode
  left?: string | ReactNode
  onClickLeft?: () => void
  right?: string | ReactNode
  onClickRight?: () => void
  isWhite?: boolean
}

export const BasicHeader = (props: IBasicProps) => {
  return (
    <div className={styles.basic_content}>
      <div
        className={styles.basic_left}
        onClick={() =>
          props?.onClickLeft ? props.onClickLeft() : closeCurWindow()
        }
      >
        {props?.left ? (
          props.left
        ) : (
          <div
            className={clsx(
              styles.basic_back,
              props.isWhite && styles.basic_back_white
            )}
          />
        )}
      </div>
      <div
        className={clsx(
          styles.basic_title,
          props.isWhite && styles.basic_title_white
        )}
      >
        <div className="no-flip-over">
          {props?.title ? props.title : 'hiya'}
        </div>
      </div>
      <div className={styles.basic_right} onClick={() => props?.onClickRight && props?.onClickRight()}>
        {props?.right ? (
          props.right
        ) : (
          <div
            className={clsx(
              styles.basic_rule,
              props.isWhite && styles.basic_rule_white,
              'no-flip-over'
            )}
          />
        )}
      </div>
    </div>
  )
}

type INormalProps = Partial<IBasicProps> & {
  fixedProps?: Partial<IBasicProps>
}

export const NormalHeader = (props: INormalProps) => {
  const {
    deviceinfo: {h_web_top},
  } = useEnv()

  const container = useRef<HTMLDivElement>(null)
  const [hasScroll, setHasScroll] = useState(false)
  const handleContainerScroll = (e) => {
    const {scrollTop} = e.target

    if (scrollTop > 0) {
      setHasScroll(true)
    } else {
      setHasScroll(false)
    }
  }
  useEffect(() => {
    container.current = document.querySelector<HTMLDivElement>(
      '.AppMain>.toastModal_scroll'
    )
    const throttleScroll = throttle(handleContainerScroll, 200)
    container.current?.addEventListener('scroll', throttleScroll)
    return () =>
      container.current?.removeEventListener('scroll', throttleScroll)
  }, [])

  return (
    <div className={styles.normal}>
      <div style={{paddingTop: h_web_top}}>
        <BasicHeader {...props} isWhite={props.isWhite} />
      </div>
      {hasScroll && (
        <div className={styles.normal_fixed} style={{paddingTop: h_web_top}}>
          <BasicHeader {...props} isWhite={false} {...props.fixedProps} />
        </div>
      )}
    </div>
  )
}
